<template>

  <div @click="imageClick(image)" :class="'GlowImage '+state+' '+colour" :style="mystyle">
    <div v-if="label" class="imageLabel"><p>{{label}}</p></div>
    <slot></slot>
  </div>
 
</template>

<script>
export default {
  props: {
    image: null,
    label:null,
    width: {
      type: String,
      default: "80"
    },
    colour: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  mounted(){
    console.log(this.image)
  },
  computed: {
    imagePath(){
      if(this.image.imageName){
        return 'experts/'+this.image.imageName+'.png'
      }else if(this.image.thumbnail){
        return "thumbnails/"+this.image.thumbnail
      }else{
        return 'experts/'+this.image.name+'.png'
      }
    },
    mystyle() {
      let style=""
       
       if(this.image.imageName){
         try{
        var url=require('../assets/images/'+this.imagePath)
        style+="background-image:url('"+url+"');"
         }
         catch(error){
           
         }
      }else if(this.image.name){
        var url=require('../assets/images/'+this.imagePath)
        style+="background-image:url('"+url+"');"
      }
      return style+"width:" + this.width + "px;margin-bottom:20px;";
    },
    state() {
      if (this.image) {
        return this.image.state;
      }
      return "";
    }
  },
  methods: {
    
    imageClick(image) {
      console.log(image);
      if (image) {
        image.state = !image.state;
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";

.GlowImage {
  text-align: center;
  width: 30px;
  height: 30px;
  border: solid 3px #0bf;
  background-color: $glow-bg;
;
  box-shadow: inset 0px 0px 20px 0px;
  color: #0bf;
  margin: 5px;
  line-height: 30px;
  position: relative;
  display: inline-block;
  cursor: pointer;
  background-size: contain;
  
}
.imageLabel{
   display: flex; 
   width: 116%;
    left: -8%;
    position: absolute;
    line-height: 22px;
    top:170px;
    border-radius:5px;
    background-color:#00113377;
    p { 
        margin: auto; /* Important */ 
        text-align: center; 
      } 
}
.GlowImage.true {
  border: solid 3px #0ff;
  background-color: #0ff;
}
.GlowImage:hover {
  border: solid 3px #0ff;
  color: #0ff;
}
.GlowImage.true:hover {
  border: solid 3px #fff;
}
</style>